import { useUserMap } from '@/features/users/users.hooks';
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection';

export function MentionComponent({
  mentionName,
  nodeKey,
}: {
  mentionName: string;
  nodeKey: string;
}) {
  const users = useUserMap('loginname');
  const [isSelected] = useLexicalNodeSelection(nodeKey);

  // if (isLoading) {
  //   return (
  //     <span
  //       className={`animate-pulse rounded bg-gray-100 px-1 text-gray-500 ${
  //         isSelected ? 'ring-2 ring-blue-500 ring-offset-1' : '' }`}
  //     >
  //       @{mentionName}
  //     </span>
  //   );
  // }
  const user = users.get(mentionName);

  return (
    <span
      className={`rounded bg-blue-50 px-1 text-blue-600 dark:bg-blue-950/50 dark:text-blue-300
        ${isSelected ? 'ring-2 ring-blue-500 ring-offset-1' : ''}`}
      title={user?.name ? `${user.name} (${user.loginname})` : mentionName}
    >
      @{mentionName}
    </span>
  );
}
